import React, {useEffect, useState} from "react";
import {DialogTypes} from "../dialog/Dialog.types";
import {HIDE_NEED_CONFIRM_DIALOG, REMOVE_NEED_CONFIRM_COUPON_EVENT} from "../../store/spirs/actions";
import {useDispatch} from "react-redux";

export const AddToCouponDialog: React.FC<DialogTypes & { className?: string }> = (props) => {
    const {isOpen, onClose, children, className = "", closeOnButton = false, closeOnOutsideClick = true, anchorEl, anchorElId} = props;
    const [showModal, setShowModal] = React.useState(false);
    const [adjustedLeft, setAdjustedLeft] = useState(0);
    const [arrowPosition, setArrowPosition] = useState("calc(50% - 12px)");
    const ref = React.useRef<HTMLDivElement>(null);

    const dispatch = useDispatch();

    const rect = anchorEl?.getBoundingClientRect();

    React.useEffect(() => {
        setShowModal(isOpen);
    }, [isOpen, anchorElId])

    React.useEffect(() => {
        function handleClickOutside(event: MouseEvent): void {
            if (!closeOnOutsideClick) return;
            const screenWidth = window.innerWidth;
            if (screenWidth > 821) {
                if (ref.current && !anchorEl || anchorEl && !ref.current?.contains(event.target as Node) && anchorElId === anchorEl.id ) {
                    dispatch(REMOVE_NEED_CONFIRM_COUPON_EVENT());
                    dispatch(HIDE_NEED_CONFIRM_DIALOG());
                }
            }
        }

        document.addEventListener('click', handleClickOutside as EventListener);
        return () => {
            document.removeEventListener('click', handleClickOutside  as EventListener);
        };
    }, [anchorEl, isOpen, ref.current, dispatch, anchorElId]);

    useEffect(() => {
        if (anchorEl && isOpen) {
            const rect = anchorEl.getBoundingClientRect();
            const popupWidth = 416;
            const viewportWidth = window.innerWidth;

            let left = rect.left - 187;
            let arrowLeft = "calc(50% - 12px)"; // Центрированная позиция по умолчанию

            // Проверяем правую границу
            if (left + popupWidth > viewportWidth) {
                left = viewportWidth - popupWidth - 10;
                // Корректируем стрелку при правом выравнивании
                const arrowOffset = rect.left - left + (rect.width / 2) - 8.5; // 8.5 = 17px / 2
                arrowLeft = `${Math.max(20, Math.min(popupWidth - 20, arrowOffset))}px`;
            }

            // Проверяем левую границу
            if (left < 10) {
                left = 10;
                // Корректируем стрелку при левом выравнивании
                const arrowOffset = rect.left - left + (rect.width / 2) - 8.5;
                arrowLeft = `${Math.max(20, Math.min(popupWidth - 20, arrowOffset))}px`;
            }

            // Если позиция не изменилась, но нужно центрировать стрелку относительно anchor элемента
            if (left === rect.left - 187) {
                const arrowOffset = rect.left - left + (rect.width / 2) - 8.5;
                arrowLeft = `${arrowOffset}px`;
            }

            setAdjustedLeft(left);
            setArrowPosition(arrowLeft);
        }
    }, [anchorEl, isOpen]);

    return (
        <>
            {showModal && (
                <>
                    <div
                        className="absolute tablet:z-10"
                        style={{
                            top: `${rect?.top as number + 40}px`,
                            left: `${adjustedLeft}px`
                        }}
                    >
                        <div className="border-0 rounded-lg relative flex flex-col w-full outline-none focus:outline-none" ref={ref}>
                            <div
                                className="absolute -top-2 w-[17px] h-[17px] bg-white transform rotate-45 border-t border-l bg-[#272D33] border-[#EACD40] z-9"
                                style={{ left: arrowPosition }}
                            ></div>
                            {children}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
